import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import { getTimeOffListApi, getTimeSheetListApi } from "../../API/API";
import { alertNotification } from "../../components/TopNotification/alertNotification";

function* getTimeOffList(action) {
  try {
    const response = yield call(() => getTimeOffListApi(action.payload));
    yield put({
      type: types.TIME_OFF_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({ type: types.TIME_OFF_FAILURE, error });
  }
}

export function* watchGetTimeOffListSaga() {
  yield takeEvery(types.TIME_OFF_REQUESTED, getTimeOffList);
}
